export const tabsNames = {
  under_review_exact: 'Exact matches',
  under_review_close: 'Similar matches',
  under_review: 'Review',
  approved: 'Approved',
  shortlisted: 'Shortlisted',
  interested: 'Interested',
  replied_interested: 'Interested',
  needs_input: 'Needs Input',
  question: 'Needs Input',
  awaiting_reply: 'Awaiting Reply',
  contacted: 'Contacted',
  interviewing: 'Interviewing',
  archived: 'Archived',
  passed: 'Passed',
  not_interested: 'Not Interested',
  warm_leads_recruiter: 'Interested',
  warm_leads_hm: 'Interested',
  warm_leads_question: 'Needs Attention',
  manager_review: 'Manager Review',
  warm_leads_hm_approved: 'Scheduling',
  warm_leads_awaiting_info: 'Awaiting Reply',
  awaiting_info: 'Awaiting Reply',
  great_fit: 'Great Fit',
  borderline: 'Borderline Fit',
  poor_fit: 'Poor Fit',
  responded: 'Responded',
  rejected: 'Rejected',
};

export const tabsOrder = {
  1: 'UNDER_REVIEW',
  2: 'IMPORTED',
  3: 'APPROVED',
  4: 'REJECTED',
  5: 'OUTREACH_EMAIL',
  6: 'OUTREACH_MANUAL',
  7: 'OUTREACH_LINKEDIN_INMAIL',
  8: 'INTERVIEW',
  9: 'NOT_INTERESTED',
  10: 'FOLLOWUP_1',
  11: 'FOLLOWUP_2',
  12: 'FOLLOWUP_3',
  13: 'OUTREACH_LINKEDIN_INVITATION',
  14: 'CUSTOM_1',
  15: 'CUSTOM_2',
  16: 'CUSTOM_3',
  17: 'CUSTOM_4',
  18: 'CUSTOM_5',
  19: 'OUTREACH_LINKEDIN_MESSAGE',
  20: 'OUTREACH_EMAIL_SCHEDULED',
  21: 'WARM_LEADS_RECRUITER',
  22: 'WARM_LEADS_HM',
  23: 'WARM_LEADS_HM_APPROVED',
  24: 'WARM_LEADS_QUESTION',
  25: 'WARM_LEADS_AWAITING_INFO',
  26: 'TRAINING_POSITIVE',
  27: 'TRAINING_NEGATIVE',
};

export const allowAutoFillTemplateTabs = [
  'under_review_close',
  'under_review_exact',
  'review',
  'shortlisted',
];

export const SELF_SERVE_TABS = [
  'WARM_LEADS_HM',
  'WARM_LEADS_QUESTION',
  'WARM_LEADS_HM_APPROVED',
  'INTERVIEWING',
  'CONTACTED',
  'WARM_LEADS_AWAITING_INFO',
  'PASSED',
  'NOT_INTERESTED',
];
export const AUTOPILOT_USER_TABS = [
  'WARM_LEADS_HM',
  'WARM_LEADS_HM_APPROVED',
  'INTERVIEWING',
  'PASSED',
];
export const AUTOPILOT_ADMIN_TABS = [
  'WARM_LEADS_RECRUITER',
  'WARM_LEADS_QUESTION',
  'WARM_LEADS_HM',
  'WARM_LEADS_HM_APPROVED',
  'INTERVIEWING',
  'CONTACTED',
  'WARM_LEADS_AWAITING_INFO',
  'PASSED',
  'NOT_INTERESTED',
];
export const AUTOPILOT_NEEDS_ATTENTION_TABS = [
  'WARM_LEADS_HM',
  'WARM_LEADS_QUESTION',
  'WARM_LEADS_HM_APPROVED',
  'INTERVIEWING',
  'PASSED',
  'NOT_INTERESTED',
];
export const NAVIGATOR_TABS = [
  'UNDER_REVIEW',
  'APPROVED',
  'CONTACTED',
  'INTERVIEWING',
  'PASSED',
  'NOT_INTERESTED',
];

export const NAVIGATOR_TABS_V2 = [
  'UNDER_REVIEW_EXACT',
  'UNDER_REVIEW_CLOSE',
  'SHORTLISTED',
  'CONTACTED',
  'RESPONDED',
  'INTERVIEWING',
  'ARCHIVED',
];

export const INBOUND_SCORING_TABS = [
  'GREAT_FIT',
  'BORDERLINE',
  'POOR_FIT',
  'APPROVED',
  'ARCHIVED',
];

export const INBOUND_SCORING_BUCKET_TABS_OPTIONS = [
  {
    title: 'Great fit',
    value: 'GREAT_FIT',
  },
  {
    title: 'Borderline fit',
    value: 'BORDERLINE',
  },
  {
    title: 'Poor fit',
    value: 'POOR_FIT',
  },
];

export const INBOUND_SCORING_BUCKET_TABS = [
  'GREAT_FIT',
  'BORDERLINE',
  'POOR_FIT',
];

export const highlightedColorTabs = ['Interested', 'Needs input'];

export const MAP_NAVIGATOR_TABS_V2 = {
  UNDER_REVIEW: 'UNDER_REVIEW',
  SHORTLISTED: 'SHORTLISTED',
  CONTACTED: 'CONTACTED',
  REPLIED_INTERESTED: 'INTERESTED',
  QUESTION: 'NEEDS_INPUT',
  AWAITING_INFO: 'AWAITING_REPLY',
  INTERVIEWING: 'INTERVIEWING',
  REJECTED: 'ARCHIVED',
  NOT_INTERESTED: 'ARCHIVED',
  PASSED: 'ARCHIVED',
};

export const archivedTabs = ['Archived'];

export const tabKeys = {
  RESPONDED: 'responded',
  SHORTLISTED: 'shortlisted',
  ARCHIVED: 'archived',
  INTERVIEWING: 'interviewing',
};

export const candidateStatuses = {
  PASSED: 'PASSED',
  AWAITING_INFO: 'AWAITING_INFO',
  NOT_INTERESTED: 'NOT_INTERESTED',
  QUESTION: 'QUESTION',
  REPLIED_INTERESTED: 'REPLIED_INTERESTED',
  INTERVIEWING_PHONE_EMAIL: 'INTERVIEWING_PHONE_EMAIL',
  INTERVIEWING: 'INTERVIEWING',
};
